import React from "react";

/* Industry / sector mark — the buildings glyph on the result card. */
export const SectorIcon = ({ size = 13, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden="true"
    focusable="false"
    className={className}
  >
    <path
      d="M2 13.5V6l4-2.5V13.5M6 13.5V3l5 2v8.5M11 13.5V6l3 1.5v6M1.5 13.5h13"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SectorIcon;
